import routineReducerFactory from "./routineReducerFactory";
import {fetchProductCategories} from "../actions/routines";

const productCategories = routineReducerFactory(fetchProductCategories, {data: []});

export default productCategories;